'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteral([''], ['']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n'], ['\n  margin-bottom: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _H = require('../elements/headings/H2');

var _H2 = _interopRequireDefault(_H);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _pickValidProps = require('react-utils/pickValidProps');

var _pickValidProps2 = _interopRequireDefault(_pickValidProps);

var _UIIllustration = require('../image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _illustrationName = require('../utils/propTypes/illustrationName');

var _Style = require('../core/Style');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MessageOuter = (0, _styledComponents2.default)(_UISection2.default).withConfig({
  displayName: 'UIResultsMessage__MessageOuter'
})(_templateObject);

var MessageBody = _styledComponents2.default.div.withConfig({
  displayName: 'UIResultsMessage__MessageBody'
})(_templateObject2);

var MessageImage = (0, _styledComponents2.default)(_UIIllustration2.default).withConfig({
  displayName: 'UIResultsMessage__MessageImage'
})(_templateObject3, (0, _Style.remCalc)(40));

var defaultIllustrationProps = { width: 175 };

exports.default = _react2.default.createClass({
  displayName: 'UIResultsMessage',

  propTypes: {
    Body: _react.PropTypes.func,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    illustration: (0, _illustrationName.getIllustrationNamePropType)(),
    illustrationProps: _react.PropTypes.object,
    Image: RenderProp.getPropType(_UIIllustration2.default),
    title: (0, _createLazyPropType2.default)(_react.PropTypes.node)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Body: MessageBody,
      Image: MessageImage,
      illustrationProps: defaultIllustrationProps
    };
  },
  renderImage: function renderImage(_ref) {
    var illustration = _ref.illustration,
        illustrationProps = _ref.illustrationProps,
        Image = _ref.Image;

    if (!illustration && !Image) return null;

    var computedIllustrationProps = _extends({}, defaultIllustrationProps, illustrationProps);

    return _react2.default.createElement(Image, _extends({
      name: illustration
    }, (0, _pickValidProps2.default)(_UIIllustration2.default, computedIllustrationProps)));
  },
  renderTitle: function renderTitle(title) {
    if (!title) return null;
    if (_react2.default.isValidElement(title)) return title;

    return _react2.default.createElement(
      _H2.default,
      null,
      (0, _lazyEval2.default)(title)
    );
  },
  render: function render() {
    var _props = this.props,
        Body = _props.Body,
        children = _props.children,
        className = _props.className,
        illustration = _props.illustration,
        illustrationProps = _props.illustrationProps,
        Image = _props.Image,
        title = _props.title,
        rest = _objectWithoutProperties(_props, ['Body', 'children', 'className', 'illustration', 'illustrationProps', 'Image', 'title']);

    return _react2.default.createElement(
      MessageOuter,
      _extends({}, rest, { className: className, role: 'alert', use: 'island' }),
      this.renderImage({
        illustration: illustration,
        illustrationProps: illustrationProps,
        Image: Image
      }),
      this.renderTitle(title),
      _react2.default.createElement(
        Body,
        null,
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/results/UIResultsMessage.js
// module id = 1304
// module chunks = 3